import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" {...props}><path d="M8 14.7A6.7 6.7 0 108 1.3a6.7 6.7 0 000 13.4z" /><path d="M9.9 9.9V6.1H6.1m0 3.8l3.8-3.8" /></svg>;